import FacilityForReservation from '../../facilities/FacilityForReservation'
import {CASH_PAYMENT_STATUS, PAYMENT_TYPE, RESERVATION_TYPE} from '../../../CodeMaster'
import {AdminReserveLocationState, ReservationInfo} from './AdminReserveInterfaces'
import {ReservationClass} from '../ReservationInterfaces'

export default class AdminReserveLocationStateHelper {
    static toObject(state: AdminReserveLocationState): object {
        return JSON.parse(JSON.stringify(state))
    }

    static fromObject(json: any): AdminReserveLocationState {
        const classification: ReservationClass = json.reservationInfo.classification

        const reserveType = RESERVATION_TYPE.codeToEnumConstants(json.reservationInfo.reserveType.value)
        const reservationOptionInfos =
            json.reservationInfo.reservationOptionInfos
                ? json.reservationInfo.reservationOptionInfos.map((info: any) => {
                    return {
                        optionId: info.optionId,
                        quantity: info.quantity,
                        sortOrder: info.sortOrder,
                        paymentType: PAYMENT_TYPE.codeToEnumConstants(info.paymentType.value),
                    }
                })
                : null
        let reservationInfo: ReservationInfo
        if (classification === ReservationClass.AGENT) {
            const paymentType = json.reservationInfo.paymentType
                ? PAYMENT_TYPE.codeToEnumConstants(json.reservationInfo.paymentType.value)
                : null
            reservationInfo = {
                ...json.reservationInfo,
                reserveType,
                paymentType,
                reservationOptionInfos,
            }
        } else {
            reservationInfo = {
                ...json.reservationInfo,
                reserveType,
                reservationOptionInfos,
            }
        }

        const cashPaymentStatus = json.cashPaymentStatus
            ? CASH_PAYMENT_STATUS.codeToEnumConstants(json.cashPaymentStatus.value)
            : null

        return {
            ...json,
            reservationInfo,
            facilityData: json.facilityData
                ? FacilityForReservation.fromJsonOfInstance(json.facilityData)
                : null,
            cashPaymentStatus,
        }
    }
}
